import { ThemeColors } from '~/themes/colors'

interface CallContactButtonMenuColors {
  Container: {
    Background: ThemeColors
  }
  ItemContainer: {
    Hover: {
      Background: ThemeColors
    }
  }
  ItemBadge: {
    Background: ThemeColors
    FontColor: ThemeColors
  }
}
export const callContactButtonMenuColors: CallContactButtonMenuColors = {
  Container: {
    Background: {
      default: 'white',
    },
  },
  ItemContainer: {
    Hover: {
      Background: {
        default: 'gray.300',
      },
    },
  },
  ItemBadge: {
    Background: {
      default: 'gray.600',
    },
    FontColor: {
      default: 'white',
    },
  },
}

interface CallContactButtonColors {
  Button: {
    Background: ThemeColors
    Hover: {
      Background: ThemeColors
      BoxShadow: ThemeColors
    }
    Active: {
      Background: ThemeColors
      BoxShadow: ThemeColors
    }
  }
  ButtonIcon: {
    FontColor: ThemeColors
  }
  ButtonText: {
    FontColor: ThemeColors
  }
}
export const callContactButtonColors: CallContactButtonColors = {
  Button: {
    Background: {
      default: 'blue.900',
    },
    Hover: {
      Background: {
        default: 'blue.900',
      },
      BoxShadow: {
        default: 'mask.blue.900.20',
      },
    },
    Active: {
      Background: {
        default: 'blue.1100',
      },
      BoxShadow: {
        default: 'mask.blue.900.20',
      },
    },
  },
  ButtonIcon: {
    FontColor: {
      default: 'white',
    },
  },
  ButtonText: {
    FontColor: {
      default: 'white',
    },
  },
}
